import { createSlice } from '@reduxjs/toolkit';

const moduleAccessSlice = createSlice({
  name: 'moduleAccess',
  initialState: {
    data: [],
    loading: false,
    error: null,
    companyModuleDetail: null,
    modulesLoading: false,
    modulesError: null,
    updateSaving: false,
    updateError: null,
    updateSuccessMessage: null,
  },
  reducers: {
    fetchModuleAccessRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchModuleAccessSuccess: (state, action) => {
      state.loading = false;
      state.error = null;
      state.data = action.payload;
    },
    fetchModuleAccessFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    fetchCompanyModuleAccessRequest: (state) => {
      state.modulesLoading = true;
      state.modulesError = null;
    },
    fetchCompanyModuleAccessSuccess: (state, action) => {
      state.modulesLoading = false;
      state.modulesError = null;
      state.companyModuleDetail = action.payload ?? null;
    },
    fetchCompanyModuleAccessFailure: (state, action) => {
      state.modulesLoading = false;
      state.modulesError = action.payload;
    },
    clearCompanyModuleDetail: (state) => {
      state.companyModuleDetail = null;
      state.modulesError = null;
    },
    setCompanyModuleAccess: (state, action) => {
      const { moduleName, access } = action.payload;
      if (!state.companyModuleDetail?.modules) return;
      const mod = state.companyModuleDetail.modules.find((m) => m.module_name === moduleName);
      if (mod) mod.access = access;
    },
    updateModuleAccessRequest: (state) => {
      state.updateSaving = true;
      state.updateError = null;
    },
    updateModuleAccessSuccess: (state, action) => {
      state.updateSaving = false;
      state.updateSuccessMessage = action.payload ?? null;
    },
    updateModuleAccessFailure: (state, action) => {
      state.updateSaving = false;
      state.updateError = action.payload;
    },
    clearModuleAccessUpdateFeedback: (state) => {
      state.updateError = null;
      state.updateSuccessMessage = null;
    },
  },
});

export const {
  fetchModuleAccessRequest,
  fetchModuleAccessSuccess,
  fetchModuleAccessFailure,
  fetchCompanyModuleAccessRequest,
  fetchCompanyModuleAccessSuccess,
  fetchCompanyModuleAccessFailure,
  clearCompanyModuleDetail,
  setCompanyModuleAccess,
  updateModuleAccessRequest,
  updateModuleAccessSuccess,
  updateModuleAccessFailure,
  clearModuleAccessUpdateFeedback,
} = moduleAccessSlice.actions;

export default moduleAccessSlice.reducer;
